export const FACEBOOK_LINK = 'https://www.facebook.com/Silver-Logistics-102265198645553 ';
export const LINKEDIN_LINK = 'https://www.linkedin.com/company/silverlogistics';
export const GOOGLE_MAP_LINK = 'https://goo.gl/maps/XY1brXorkcaPCAfx8';
